import { render, staticRenderFns } from "./baseDataXT.vue?vue&type=template&id=4d1f0975&scoped=true&"
import script from "./baseDataXT.vue?vue&type=script&lang=js&"
export * from "./baseDataXT.vue?vue&type=script&lang=js&"
import style0 from "./baseDataXT.vue?vue&type=style&index=0&id=4d1f0975&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1f0975",
  null
  
)

export default component.exports